<template>
  <transition name="loading-fade">
    <div
            v-show="visible"
            :style="{ backgroundColor: background || '' }"
            class="loading-mask">
      <div class="loading-spinner">
        <spinner :type="type"></spinner>
        <p v-if="text" class="loading-text">{{ text }}</p>
      </div>
    </div>
  </transition>
</template>

<script>
import spinner from '@/components/spinner'
export default {
  components: {
    spinner
  },
  computed: {
    visible () { return this.$store.state.visible }
  },
  watch: {
    visible (val) {
    }
  },
  data () {
    return {
      text: '加载中...',
      type: 'audio-ball',
      background: null,
      delay: 100
    };
  }
};
</script>

<style lang="less">
  .loading-fade-enter, .loading-fade-leave-to{
    opacity: 0;
  }
  .loading-mask {
    position: absolute;
    z-index: 20;
    // background-color: rgba(0, 0, 0, .8);
    margin: 0;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    -webkit-transition: opacity .5s;
    transition: opacity .5s
  }
  .loading-spinner{
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    text-align: center;
  }
  .loading-text{
    padding-top: 10px;
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/components/loading.vue